// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Gb9puBX7043FuNj7rr8c{margin:0}.nRNvcQHAIhEALeikuHr4{width:100%}.bxVyKWHp094PYhekXx96{border-bottom:1px solid var(--border-neutral-default);padding:4px 4px 4px 8px;display:flex}.sa2qd15XAT48rgabLhOA{padding:4px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"icon": `Gb9puBX7043FuNj7rr8c`,
	"picker": `nRNvcQHAIhEALeikuHr4`,
	"header": `bxVyKWHp094PYhekXx96`,
	"items": `sa2qd15XAT48rgabLhOA`
};
export default ___CSS_LOADER_EXPORT___;
